import { ILicenseAllowance } from '@module/license/models';
import { handleErrors, SITE_API_URI } from '@service/constants';
import SiteApiClient from '@service/siteApiClient';

const client = new SiteApiClient(SITE_API_URI);

export function requestAllocationGet(siteId: number, accessToken: string) {
    return new Promise(
        (resolve, reject) => {
            client.getAllServices(siteId, accessToken).then((data: any) => {
                const allocations = data.allocations.map(
                    (x: any) => {
                        return toAllocation(x, data.site);
                    }
                );
                resolve({ site: data.site, licenseAllowances: allocations });
            }).catch((err: any) => {
                reject(err);
            });
        }
    );
}

export function requestNewAllocationGet(siteId: number, accessToken: string) {
    return new Promise(
        (resolve, reject) => {
            const req = client.getNewAllocation(siteId, accessToken);
            req.then((data: any) => {
                resolve(data);
            }).catch((err: any) => {
                reject(err);
            });
        }
    );
}

export function requestAllocationPost(allocation: ILicenseAllowance, accessToken: string) {
    allocation.id = 0;
    return new Promise(
        (resolve, reject) => {
            const req = client.addAllocation(allocation, accessToken);
            req.then(handleErrors).then(data => {
                resolve(toAllocationResponse(data));
            }).catch((err: any) => reject(err));
        }
    );
}

export function requestAllocationPut(allocation: ILicenseAllowance, accessToken: string) {
    return new Promise(
        (resolve, reject) => {
            const req = client.updateAllocation(allocation, accessToken).then(data => resolve(data)).catch((err: any) => {
                reject(err);
            });
        }
    );
}

export function requestAllocationDelete(allocation: ILicenseAllowance, accessToken: string) {
    return new Promise(
        (resolve, reject) => {
            const req = client.deleteAllocation(allocation, accessToken).then(r => {
                resolve(allocation);
            }).catch((err: any) => {
                reject(err);
            });
        }
    );
}

function toAllocation(data: any, site: any) {
    return {
        id: data.id,
        siteId: site.id,
        site,
        expirationDateUtc: { value: data.expirationDateUtc, valid: true },
        licensableService: data.licensableService,
        productOrderNumber: { value: data.poNumber, valid: true },
        totalAssetAllocation: { value: data.totalAssetAllocation, valid: true },
        isBeingEdited: false,
    };
}

function toAllocationResponse(data: any) {
    const allocationResponse: ILicenseAllowance = {
        id: data.id,
        siteId: data.siteId,
        site: data.site,
        expirationDateUtc: { value: data.expirationDateUtc, valid: true },
        licensableService: data.licensableService,
        productOrderNumber: { value: data.poNumber, valid: true },
        totalAssetAllocation: { value: data.totalAssetAllocation, valid: true },
        isBeingEdited: false,
        discriminator: ''
    };
    return allocationResponse;
}



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./src/services/servicesDataService.ts